
import React, { useState } from 'react';
import { Eye, EyeOff, Lock } from 'lucide-react';
import InputField from './InputField';

interface PasswordInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  id,
  label,
  value,
  onChange,
  error,
  placeholder = "••••••••"
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputField
      id={id}
      label={label}
      type={showPassword ? "text" : "password"}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      icon={<Lock className="w-5 h-5 text-gray-400" />}
      rightIcon={
        <button
          type="button"
          className="focus:outline-none"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <EyeOff className="w-5 h-5 text-gray-400" />
          ) : (
            <Eye className="w-5 h-5 text-gray-400" />
          )}
        </button>
      }
    />
  );
};

export default PasswordInput;
